import {  AppBar,  Box,  Button,  Chip,  Grid,  Tab,  Tooltip,  Snackbar,  Typography,  IconButton,  TextField, Link, Divider,} from '@material-ui/core';
import { AppNoBodyPadding } from '@components/app-settings';
import { ScrollSpyBoundry } from '@components/scroll-spy';
import { amber, pink, purple } from '@material-ui/core/colors';

import { SectionBasicDetails } from './sections/section-basic';
import { SectionContentServices } from './sections/section-services-content';
import { SectionHasClientContentServices } from './sections/section-has_client-service-content';
import { SectionIsClientContentServices } from './sections/section-is_client-service-content';
import { SectionContact } from './sections/section-contact';
import { SectionMetadata } from './sections/section-metadata';
import { SectionAdditionalDetails } from './sections/section-additional-detals';
import { SectionSocial } from './sections/section-social';
import { CompanyFormStateProvider } from './common';
import { useCompanyMaster, useFormSnackbarError, windowObj } from '@lib/common';
import { SectionTypes } from './sections/section-types';
import { SectionServices } from './sections/section-services';
import { SectionBadges } from './sections/section-badges';
import { SectionGroupCompanies } from './sections/section-group-companies';
import styled from 'styled-components';
import { FormProvider, useForm } from 'react-hook-form';
import React, { useMemo, useEffect, useState, useCallback } from 'react';
import { CompanyBasicFormField } from './fields';
import SaveIcon from '@material-ui/icons/SaveRounded';
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import { CompanyFormAdapter } from './company-fom-adapter';
import { vestResolver } from '@hookform/resolvers/vest';
import { companyValidationSuite } from './validatons';
import { CompanyInfo, UpdateCompanyRequest } from './company.types';
import { ScrollSpyMuiTabs } from '@components/mui/tabs';
import { TimeAgo } from '@components/time-ago';
import { isValid } from 'date-fns';
import TimelapseTwoToneIcon from '@material-ui/icons/TimelapseTwoTone';
import { PublishStatusChip } from '@components/publish-status-chip';
//import { ServiceInsights } from './service-insights';
import { SectionAssociatedPerson } from './sections/section-associated-person';
import { MediaSection } from './sections/media_section';
import { rbac } from '@lib/common';
import { PoliciesPracticesSection } from './sections/policies-practices-section';
import { TargetSection } from './sections/targets-section';
import { useSnackbar } from 'notistack';
import { KeyboardArrowRight, KeyboardArrowLeft } from '@material-ui/icons';
import { http, pintHttp } from '@api/client';
import { map } from 'rxjs/operators';
import { mockCompanyData } from './mock-data'; // if placed in another file
import { cleanInvalidData, filterClientServices, filterCompanyTypes, getUnlockedSections, normalizeCompanyData, preFillForm_Company } from '../utils';
import { getAISummaryURL } from '@api/deals';

interface CompanyFormProps {
  edit?: boolean;
  defaultValue?: CompanyInfo;
  logs?: any;
  onFinish?: (company: UpdateCompanyRequest) => any;
}

const CompanyForm = ({
  edit = false,
  defaultValue = null,
  onFinish = null,
  logs = null,
}: CompanyFormProps = {}) => {
    const { master: services, loading } = useCompanyMaster('services');
    const { master: types, loading :loadingTypes } = useCompanyMaster('types');
    useEffect(()=>{
    },[loading,services,types,loadingTypes])
   const formValue = useMemo(() => {
    if (!defaultValue) return null;

    // If edit → convert from API structure
    if (edit) {
      return CompanyFormAdapter.toForm(defaultValue);
    }

    // If create → already mapped correctly from Excel
    return defaultValue;
  }, [defaultValue, edit]);

    const [state, setState] = React.useState({
      open: false,
      vertical: 'top',
      horizontal: 'right',
    });

  const position = {
    vertical: 'top',
    horizontal: 'right',
  };

  const { vertical, horizontal, open } = state;

  const handleClick = () => {
    setState({ ...state, open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const [isDisabled, setIsDissabled] = React.useState(true);

  const form = useForm({
    resolver: vestResolver(companyValidationSuite),
    ...(formValue
      ? {
          defaultValues: formValue,
        }
      : {}),
  });

  useEffect(() => {
    if (!edit &&defaultValue) {
      form.reset(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    form.register('verified_sections');
  }, [form.register]);

  const formError = useFormSnackbarError();
  const submit = useMemo(
    () =>
      form.handleSubmit(values => {
          const unlockedSections = getUnlockedSections(
             values?.verified_sections,
             edit
           );
 
         if (unlockedSections.length > 0) {
           enqueueSnackbar(
             <div>
                   <Typography>
                {unlockedSections.length === 10
                  ? 'Please verify & lock all sections before saving.'
                  : 'Please verify & lock the following sections before saving:'}
              </Typography>

              {unlockedSections.length !== 10 && (
                <Box
                  mt={1}
                  display="flex"
                  flexWrap="wrap"
                  style={{gap: '8px',}}
                >
                  {unlockedSections.map((section) => (
                    <Chip
                      key={section}
                      label={section}
                      size="small"
                    //  color="error"
                      variant="outlined"
                      style={{ fontSize: '0.75rem', fontWeight: 500, textTransform: 'capitalize' ,backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '12px'}}
                    />
                  ))}
                </Box>
              )}
             </div>     
           , { variant: 'error' });
 
           return;
	         }
        onFinish && onFinish(CompanyFormAdapter.fromForm(values, edit ? defaultValue : null));
      }, formError),
    [form.handleSubmit, onFinish, edit, defaultValue]
  );
  const modifiedTime = useMemo(() => {
    if (edit && defaultValue) {
      const time = new Date(logs.created_at || defaultValue.modified_at || defaultValue.created_at);
      return isValid(time) && time;
    }
    return false;
  }, [defaultValue, edit]);

  const publishStatus = edit && defaultValue && defaultValue.company_publish_ready;

  // AI SmartFetch state
  const [companyInfoUrl, setCompanyInfoUrl] = useState('');
  const [companyInfoLoading, setCompanyInfoLoading] = useState(false);
  const [companyInfoResult, setCompanyInfoResult] = useState(null);

  // Log companyInfoResult whenever it changes
  useEffect(() => {}, [companyInfoResult]);

  // Log published_date whenever it changes
  const publishedDate = form.watch('published_date');
  useEffect(() => {}, [publishedDate]);

  const [isUnfreezed, setIsUnfreezed] = useState(true);
  const [popupOpen, setPopupOpen] = useState(false);
  const [lastFetchedUrl, setLastFetchedUrl] = useState<string | null>(null);

  const { enqueueSnackbar } = useSnackbar();
  const preFillForm = useCallback(
    (prefillData: any, url: string) => {
       preFillForm_Company(form, prefillData,enqueueSnackbar);
    },
    [form, enqueueSnackbar]
  );

  // AI SmartFetch function
  const getCompanyInfo = useCallback(
    (url: string, currentServices,currentTypes) => {
      // flag or env variable to force mock mode
     // console.log("ENV:",  process.env.NODE_ENV)
      const useMock = process.env.NODE_ENV === 'pro'; //development
      setCompanyInfoLoading(true);
      setCompanyInfoResult(null);
      setPopupOpen(false)

      if (useMock) {
        console.log('⚡ Using mock data only (dev mode)');
        const parsedData = {
          Relevance: mockCompanyData['Relevance'] || null,
          'Key Areas': mockCompanyData['Key Area'] || [],
          ...normalizeCompanyData(mockCompanyData['Company 1'], url),
        };
        let cleanedParsedData = cleanInvalidData(parsedData);
      let preFillFormData: any;
        // ✅ Filter client services before preFillForm
        if (cleanedParsedData['Services Offered'] && currentServices?.length) {
          const filteredServices = filterClientServices(
            cleanedParsedData['Services Offered'],
            currentServices
          );
    
          preFillFormData = {
            ...cleanedParsedData,
            'Services Offered': filteredServices,
          };
        }
        // ✅ Filter company types before preFillForm
        if (cleanedParsedData['Company Type'] && currentTypes?.length) {
          const filteredTypes = filterCompanyTypes(
            cleanedParsedData['Company Type'],
            currentTypes
          );
          preFillFormData = {
            ...cleanedParsedData,
            'Company Type': filteredTypes,
          };
        }
        setCompanyInfoResult(cleanedParsedData);
        // UI updates moved here
        setPopupOpen(true);
        setIsUnfreezed(false);
        setLastFetchedUrl(url);
        preFillForm(preFillFormData, url);
        enqueueSnackbar('Company info (mock) pre-filled successfully!', { variant: 'success' });
        setCompanyInfoLoading(false);
        return; // ✅ skip API
      }

      // 🔹 Production → call API
      const payloadToSend = { api_response: { url } };
      const completeUrl = getAISummaryURL('/company_creation_prompt')/* windowObj.RAZZLE_AI_SUMMARY_COMPANY_API_URL */;
      if (!completeUrl) {
        throw new Error('AI Summary API URL is not set in environment variables');
      }

      return pintHttp
        .post(completeUrl, payloadToSend)
        .pipe(map(res => res.data))
        .subscribe({
          next: data => {
            try {
              let responseText: any =
                data?.data ||
                data?.result ||
                data?.response ||
                (typeof data === 'string' ? data : null);
              let noteMessage = '';
              let jsonString = '';

              // 1. Normalize responseText to string
              if (typeof responseText !== 'string') {
                responseText = JSON.stringify(responseText);
              }

              // 2. Extract JSON block inside ```json ... ```
              const jsonMatch = responseText.match(/```json([\s\S]*?)```/i);

              if (jsonMatch) {
                jsonString = jsonMatch[1].trim();

                // Extract anything after the JSON block -> Note
                const afterJson = responseText.split(jsonMatch[0])[1]?.trim();
                if (afterJson) {
                  noteMessage = afterJson;
                }
              } else {
                // fallback: try to use entire content (if no code block exists)
                jsonString = responseText.trim();
              }

              // 3. Parse JSON safely
              let jsonObj: any = null;
              try {
                jsonObj = JSON.parse(jsonString);
              } catch {
                jsonObj = null;
              }

              // 4. Show Note via snackbar
              if (noteMessage) {
                enqueueSnackbar(noteMessage, {
                  variant: 'info',
                  autoHideDuration: 6000,
                });
              }

              // 5. Continue with your existing logic
              let parsedData: any;

              if (jsonObj && typeof jsonObj === 'object') {
                const company = jsonObj['Company'] || {};
                // pick relevance & key_areas if they exist in response
                const relevance = jsonObj.relevance || company.relevance || null;
                const keyAreas = jsonObj.key_areas || company.key_areas || [];
                parsedData = { ...normalizeCompanyData(company, url), relevance, keyAreas };
              } else {
                parsedData = {
                  ...normalizeCompanyData(mockCompanyData['Company 1'], url),
                  Relevance: mockCompanyData['Relevance'] || null,
                  'Key Areas': mockCompanyData['Key Area'] || [],
                };
              }
              let cleanedParsedData = cleanInvalidData(parsedData);
              let preFillFormData: any = { ...cleanedParsedData };
              // ✅ Filter client services before preFillForm
              if (cleanedParsedData['Services Offered'] && currentServices?.length) {
                const filteredServices = filterClientServices(
                  cleanedParsedData['Services Offered'],
                  currentServices
                );
                preFillFormData['Services Offered'] = filteredServices;
              }

              // ✅ Filter company types before preFillForm
              if (cleanedParsedData['Company Type'] && currentTypes?.length) {
                const filteredTypes = filterCompanyTypes(
                  cleanedParsedData['Company Type'],
                  currentTypes
                );
                preFillFormData['Company Type'] = filteredTypes;
              }
              setCompanyInfoResult(cleanedParsedData);
              // UI updates moved here
              setPopupOpen(true);
              setIsUnfreezed(false);
              setLastFetchedUrl(url);
              preFillForm(preFillFormData, url);
              enqueueSnackbar('Company info retrieved and form pre-filled successfully!', {
                variant: 'success',
              });
            } catch (error) {
              console.error('❌ Error during auto pre-fill:', error);
              enqueueSnackbar('Company info retrieved, but auto pre-fill failed.', {
                variant: 'warning',
              });
            }
          },
          error: () => {
            console.error('❌ API failed, using mock data');
            const parsedData = normalizeCompanyData(mockCompanyData['Company 1'], url);
            const cleanedParsedData = cleanInvalidData(parsedData);
            setCompanyInfoResult(cleanedParsedData);
            preFillForm(cleanedParsedData, url);
            enqueueSnackbar('Using mock data due to API failure.', { variant: 'info' });
          },
          complete: () => setCompanyInfoLoading(false),
        });
    },
    [enqueueSnackbar]
  );

  // --- Unfreeze handler ---
  const handleUnfreeze = () => {
    setIsUnfreezed(true);
    setPopupOpen(false);
  };

  // --- Disable Run It button if no url or same as last fetched ---
const runItDisabled =
  companyInfoLoading ||
  loading ||   loadingTypes ||    
  !services?.length ||            // ⬅️ Ensure services are actually loaded
  !types?.length|| 
  !companyInfoUrl.trim() ||
  (isUnfreezed && companyInfoUrl === lastFetchedUrl);

  const handleGetCompanyInfo = () => {
    if (!companyInfoUrl.trim()) {
      enqueueSnackbar('Please enter a URL', { variant: 'warning' });
      return;
    }
   
  // ✅ Wait until master services are loaded
  if (loading || !services?.length) {
    enqueueSnackbar('Please wait — loading master services...', { variant: 'info' });
    return;
  }
    // ✅ Wait until master services are loaded
  if (loadingTypes || !types?.length) {
    enqueueSnackbar('Please wait — loading master company types...', { variant: 'info' });
    return;
  }

    getCompanyInfo(companyInfoUrl,services,types);
  };
  return (
    <>
      <FormProvider {...form}>
                    <Grid style={{ position: 'relative',paddingRight: popupOpen ? 0 : "4px" }} container spacing={3}>
        <CompanyFormStateProvider
          company={defaultValue}
          companyForm={formValue}
          edit={edit}
          triggerSubmit={submit}>
         {/*  <ServiceInsights> */}
          <Grid item xs={ popupOpen ? 9 : 12}>
              <AppNoBodyPadding />
              <ScrollSpyBoundry defaultItem="basic-details">
                {!edit && (
                  <Box m={2} mb={4} marginRight={4}>
                    <Box display="flex" alignItems="center" mb={0.5}>
                      <img
                        src="/images/AI_smart.jpg"
                        alt="Company Automator"
                        style={{
                          height: 60,
                          width: 80,
                          marginRight: 12,
                          objectFit: 'contain',
                          borderRadius: '20px',
                        }}
                      />
                      <Typography variant="h6" gutterBottom>
                        Company Automator
                      </Typography>
                    </Box>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
                      Drop a URL. Hit Run.
                    </Typography>
                    <Box
                      display="flex"
                      alignItems="center"
                      style={{
                        gap: '16px',
                        ...(companyInfoResult && !isUnfreezed
                          ? {
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              right: 0,
                              zIndex: 1201,
                              background: '#fff',
                              padding: '8px 24px',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                              width: '100%',
                              maxWidth: '100vw',
                            }
                          : {}),
                      }}>
                      <TextField
                        id="company-info-url"
                        name="companyInfoUrl"
                        label="Enter URL"
                        variant="outlined"
                        value={companyInfoUrl}
                        onChange={e => setCompanyInfoUrl(e.target.value)}
                        placeholder="Enter URL to get company info"
                        fullWidth
                        style={{ flexGrow: 1 }}
                        disabled={!isUnfreezed} // disable when frozen
                        InputProps={{
                          style: !isUnfreezed ? { backgroundColor: '#f5f5f5', opacity: 0.4 } : {},
                        }}
                        InputLabelProps={{
                          style: !isUnfreezed ? { color: 'rgba(0,0,0,0.4)' } : {},
                        }}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        /* onClick={
                          !companyInfoResult ? handleGetCompanyInfo : () => setIsUnfreezed(true)
                        } */
                        onClick={
                          companyInfoLoading
                            ? undefined
                            : isUnfreezed
                            ? handleGetCompanyInfo
                            : handleUnfreeze
                        }
                        disabled={runItDisabled}
                        style={{
                          width: '120px',
                          height: '40px',
                          padding: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: runItDisabled ? 0.5 : 1, // 👈 fade out when disabled
                          cursor: runItDisabled ? 'not-allowed' : 'pointer', // 👈 visual cue
                        }}>
                        {companyInfoLoading ? (
                          'Loading...'
                        ) : isUnfreezed ? (
                          <img
                            src="/images/Run_it.png"
                            alt="Run It"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                              display: 'block',
                              borderRadius: '10px',
                            }}
                          />
                        ) : (
                          'Unfreeze'
                        )}
                      </Button>
                    </Box>
                    {companyInfoResult && !isUnfreezed && <Box height={80} />}
                 
                  </Box>
                )}
                <br />
                <AppBar
                  color="secondary"
                  style={{
                    position: 'sticky',
                    top: edit ? 88: 64,
                    background: purple[800],
                    paddingRight: 24,
                  }}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <ScrollSpyMuiTabs $small>
                        <Tab value="basic-details" label="Profile" />
                        <Tab value="company-types" label="Services" />
                        {/* {edit && <Tab value="content-services-info" label="Relations" />} */}
                        {/* <Tab value="company-associated-persons" label="Associated Person" /> */}
                        <Tab value="contact-info" label="Contact" />
                        <Tab value="additional-info" label="Attributes" />
                        <Tab value="social-details" label="Social" />
                        <Tab value="metadata" label="Metadata" />
                        <Tab value="company-badges" label="Badges" />
                       {edit &&  <Tab value="content-media" label="Media" /> }
                        <Tab value="policies-practices" label="Policies" />
                        <Tab value="targets" label="Targets" />
                      </ScrollSpyMuiTabs>
                    </Grid>
                    <Grid item xs />
                    {modifiedTime && (
                      <Grid item>
                        <Tooltip title="Last updated time">
                          <Chip
                            component="time"
                            style={{ background: 'white' }}
                            icon={<TimelapseTwoToneIcon style={{ color: pink[700] }} />}
                            label={<TimeAgo time={modifiedTime} />}
                            color="primary"
                          />
                        </Tooltip>
                      </Grid>
                    )}
                    <Grid item>
                      {typeof publishStatus === 'number' && (
                        <PublishStatusChip hideManual status={`PS_${publishStatus}` as any} />
                      )}
                    </Grid>
                    <Grid item>
                      <PublishContainer>
                        <CompanyBasicFormField
                          disabled={rbac('Company_Publish', '', 'Button')}
                          name="company_publish_ready"
                          icon={<PublishRoundedIcon style={{ color: 'white' }} />}
                          hideEmptySelect
                          select
                          selectOptions={publishOptions}
                        />
                      </PublishContainer>
                    </Grid>
                    <Grid item>
                      <Button
                        onClick={submit}
                        style={{ marginRight: 10 }}
                        size="small"
                        color="primary"
                        startIcon={<SaveIcon />}
                        variant="contained"
                        disabled={!defaultValue?.editing_allowed && edit}>
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </AppBar>
                <div
                  onClick={defaultValue?.vtr_id && !defaultValue?.editing_allowed && handleClick}>
                  <Box
                    px={4}
                    style={{
                      pointerEvents: defaultValue?.vtr_id
                        ? !defaultValue.editing_allowed
                          ? 'none'
                          : 'all'
                        : 'auto',
                    }}>
                    <SectionBasicDetails />
                    <br />
                    <br />
                    <SectionTypes />
                    <br />
                    <br />
                    <SectionServices />
                   
                    <br />
                    <br />
                    <SectionContact />
                    <br />
                    <br />
                    <SectionAdditionalDetails />
                    <br />
                    <br />
                    <SectionSocial
                      social_urls={
                        defaultValue
                          ? defaultValue['social_urls']
                            ? defaultValue['social_urls']
                            : ''
                          : ''
                      }
                    />
                    <br />
                    <br />
                    <SectionMetadata
                      parent_child_imdb={
                        defaultValue
                          ? defaultValue['parent_child_imdb']
                            ? defaultValue['parent_child_imdb']
                            : ''
                          : ''
                      }
                      imdb_data={
                        defaultValue
                          ? defaultValue['imdb_data']
                            ? defaultValue['imdb_data']
                            : []
                          : []
                      }
                    />
                    <br />
                    <br />
                    <SectionBadges />
                    {/* <br />
                    <br />
                    <SectionGroupCompanies /> */}
                    <br />
                    <br />
                    <SectionAssociatedPerson />
                    <br />
                    <br />
                    {edit && (
                      <MediaSection
                        media_and_services={
                          defaultValue
                            ? defaultValue['company_services']
                              ? defaultValue['company_services']
                              : []
                            : []
                        }
                      />
                    )}
                    <br />
                    <br />
                    <PoliciesPracticesSection />
                    <br />
                    <br />
                    <TargetSection />
                     {edit && (
                      <>
                        <br />
                       {/*  <br /> */}
                        <SectionContentServices
                          services={
                            defaultValue
                              ? defaultValue['services_content']
                                ? defaultValue['services_content']
                                : []
                              : []
                          }
                          vtr_company_name={defaultValue['vtr_company_name']}
                          company_vtr_id = {defaultValue['vtr_id']}
                        />
                      </>
                    )}
                    {edit && (
                      <>
                        <br />
                        <br />
                        <SectionHasClientContentServices
                          services={
                            defaultValue
                              ? defaultValue['company_relation_has_client']
                                ? defaultValue['company_relation_has_client']
                                : []
                              : []
                          }
                          vtr_company_name={defaultValue['vtr_company_name']}
                        />
                      </>
                    )}
                    {edit && (
                      <>
                        <br />
                        <br />
                        <SectionIsClientContentServices
                          services={
                            defaultValue
                              ? defaultValue['company_relation_is_client']
                                ? defaultValue['company_relation_is_client']
                                : []
                              : []
                          }
                          vtr_company_name={defaultValue['vtr_company_name']}
                        />
                      </>
                    )}
                    <br/>
                    <br/>
                  </Box>
                </div>
              </ScrollSpyBoundry>
            </Grid>
         {/*  </ServiceInsights> */}
          {edit && (
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={open}
              onClose={handleClose}
              message={'The page is being edited by ' + defaultValue.editing_by}
              key={vertical + horizontal}
            />
          )}
          {popupOpen && <>
             <Divider orientation="vertical" flexItem />
                {companyInfoResult && popupOpen && (
                     <Grid
        item
        xs
        style={{
          padding: 0,
          position: 'sticky',
          top: 70,
          maxHeight: 'calc(100vh - 75px)',
          overflowY: 'auto',
          background:
            'linear-gradient(135deg, #039df3 0%, #017ff5 50%, #a579ea 110%)',
          boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.08)',
          borderLeft: '1px solid #ddd',
        }}
      >
        {/* Collapse Button */}
        <Box
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 10,
            boxShadow: '0px 2px 6px rgba(0,0,0,0.25)',
            backgroundColor:"#fff",
            borderRadius: '4px',
          }}
        >
          <Tooltip title="Collapse" placement="left">
            <IconButton size="small" onClick={() => setPopupOpen(false)}>
              <KeyboardArrowRight />
            </IconButton>
          </Tooltip>
        </Box>

                           {/* Response Content */}
        <Box style={{ padding: 16 }}>
          <Typography
            variant="subtitle2"
            gutterBottom
            style={{
              fontWeight: 'bold',
              fontSize: 'larger',
              marginBottom: 16,
              color: 'navy',
            }}
          >
            AI-Generated Response
          </Typography>
                              {/* your JSON rendering logic */}
                              <Box style={{ fontSize: '14px', lineHeight: '1.6' }}>
                                {(() => {
                                  let parsed;
                                  try {
                                    /* parsed =
                            typeof companyInfoResult.data === 'string'
                              ? JSON.parse(companyInfoResult.data)
                              : companyInfoResult.data; */
                                    parsed =
                                      typeof companyInfoResult === 'string'
                                        ? JSON.parse(companyInfoResult)
                                        : companyInfoResult;
                                    // Clean out "N/A" / "Not mentioned"
                                    parsed = cleanInvalidData(parsed);
                                  } catch {
                                    parsed = null;
                                  }
                                  if (!parsed)
                                    return (
                                      <Typography
                                        style={{
                                          color: 'darkred',
                                          fontSize: 'medium',
                                          fontWeight: 500,
                                          paddingTop: '20px',
                                        }}>
                                        {companyInfoResult.data}
                                      </Typography>
                                    );

                                  // Helper to recursively render any object/array
                                  function renderValue(value, parentKey = '') {
                                    if (Array.isArray(value)) {
                                      return (
                                        <Box component="ul" style={{ margin: 0, paddingLeft: 20 }}>
                                          {value.map((item, idx) => (
                                            <li key={idx}>{renderValue(item, parentKey)}</li>
                                          ))}
                                        </Box>
                                      );
                                    } else if (typeof value === 'object' && value !== null) {
                                      return (
                                        <Box style={{ marginLeft: 10 }}>
                                          {Object.entries(value).map(([k, v]) => (
                                            <Box key={k} mb={1}>
                                              <Typography
                                                style={{
                                                  fontWeight: 'bold',
                                                  color: 'darkblue',
                                                  fontSize: '16px',
                                                }}>
                                                {k}
                                              </Typography>
                                              {renderValue(v, k)}
                                            </Box>
                                          ))}
                                        </Box>
                                      );
                                    } else {
                                      // Special handling for Leadership Contacts > Name
                                      if (parentKey === 'Name') {
                                        const encodedName = encodeURIComponent(String(value));
                                        const link = `${window.location.origin}/person-management/search?filters[0].id=name&filters[0].value.$contains=${encodedName}`;
                                        return (
                                          <Link
                                            href={link}
                                            target="_blank"
                                            style={{ textDecoration: 'none' }}>
                                            <Typography
                                              component="div"
                                              style={{
                                                wordBreak: 'break-word',
                                                fontSize: '15px',
                                                color: '#FFFFFF', // bright white for high contrast
                                                fontWeight: 600,
                                                borderRadius: 4,
                                                padding: '4px 8px',
                                                display: 'inline-block',
                                                cursor: 'pointer',
                                                textDecoration: 'underline',
                                                textShadow: '0 0 5px rgba(0,0,0,0.3)', // subtle shadow to pop from background
                                                transition:
                                                  'color 0.3s ease, text-decoration 0.3s ease',
                                              }}
                                              onMouseEnter={e => {
                                                e.currentTarget.style.textDecoration = 'underline';
                                                e.currentTarget.style.color = '#FFD700'; // gold highlight on hover
                                              }}
                                              onMouseLeave={e => {
                                                e.currentTarget.style.textDecoration = 'underline';
                                                e.currentTarget.style.color = '#FFFFFF';
                                              }}>
                                              {String(value)}
                                            </Typography>
                                          </Link>
                                        );
                                      }

                                      // Default rendering for normal text values
                                      return (
                                        <Typography
                                          component="div"
                                          style={{
                                            wordBreak: 'break-word',
                                            fontSize: '15px',
                                            color: '#FFFFFF',
                                            fontWeight: 500,
                                            borderRadius: 4,
                                            padding: '4px 8px',
                                            display: 'inline-block',
                                          }}>
                                          {String(value)}
                                        </Typography>
                                      );
                                    }
                                  }
                                  return renderValue(parsed);
                                })()}
                              </Box>
                            </Box>
                            </Grid>
                          )}
          </>}
          {/* Always visible vertical expand button */}
{companyInfoResult && !popupOpen && (
  <ExpandVerticalBar onClick={() => setPopupOpen(true)}>
    <Tooltip title="Expand AI Response" placement="left">
      <Box display="flex" alignItems="center">
        <KeyboardArrowLeft />
        <span>AI-Generated Response</span>
      </Box>
    </Tooltip>
  </ExpandVerticalBar>
)}
        </CompanyFormStateProvider>
        </Grid>
      </FormProvider>
    </>
  );
};


const ExpandVerticalBar = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
  width: '30px',
  height: '250px',
  background: 'linear-gradient(135deg, #039df3 0%, #017ff5 50%, #a579ea 110%)',
  boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.08)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  writingMode: 'vertical-rl',
  textAlign: 'center',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontFamily: 'cursive',
  color: '#fff',
  fontSize: '14px',
  letterSpacing: '2px',
  borderTopLeftRadius: '8px',
  borderBottomLeftRadius: '8px',
  zIndex: 1500,

  // Optional hover/transition effects
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '-4px 0 12px rgba(0, 0, 0, 0.2)',
    background: 'linear-gradient(135deg, #0288f5 0%, #006ef3 50%, #946bea 110%)',
  },
}));
const listObj = (label: string, value: string | number) => ({ label, value });
const publishOptions = [
  listObj('Auto Decide', 0),
  listObj('Publish', 2),
  listObj('Unpublish', -1),
  listObj('Park', -2),
];

const PublishContainer = styled.div`
  margin-right: 10px;
  border-radius: 4px;
  background: ${amber[900]};
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
  select {
    padding-top: 6px;
    padding-bottom: 6px;
    color: white;
    option {
      color: black;
    }
  }
  .MuiSelect-iconOutlined {
    color: white;
  }
`;
const FixedApiResponsePopup = styled(Box)<{ open: boolean }>`
  position: fixed;
  top: 64px;
  right: 0;
  width: ${({ open }) => (open ? '33.33vw' : '32px')};
  min-width: ${({ open }) => (open ? '32px' : '32px')};
  height: calc(100vh - 64px);
  overflow-y: auto;
  background: linear-gradient(135deg, #039df3 0%, #017ff5 50%, #a579ea 110%);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.08);
  z-index: 1200;
  padding: ${({ open }) => (open ? '24px' : '0')};
  border-radius: 0 0 0 12px;
  transition: width 0.2s, padding 0.2s;
  display: flex;
  flex-direction: column;
  align-items: ${({ open }) => (open ? 'flex-start' : 'center')};
  justify-content: flex-start;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d5d8f6;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export default CompanyForm;
